import React from "react";
export const HelpBubble = () => (
  <svg fill="none" viewBox="0 0 12 14">
    <path
      d="M10.67 0H1.33C.59 0 0 .6 0 1.33v9.33C0 11.4.6 12 1.33 12H4l1.53 1.53c.26.26.68.26.94 0L8 12h2.67c.73 0 1.33-.6 1.33-1.33V1.33C12 .6 11.4 0 10.67 0zm-4 10.67H5.33V9.33h1.33v1.34h.01zM8.05 5.5l-.6.61c-.39.4-.66.74-.75 1.38-.04.28-.27.5-.57.5h-.2c-.35 0-.61-.31-.57-.65.07-.61.35-1.15.76-1.56l.83-.84c.24-.24.38-.57.38-.94 0-.73-.6-1.33-1.33-1.33-.58 0-1.08.38-1.26.9-.09.24-.29.42-.55.42h-.2c-.39 0-.65-.37-.55-.75A2.67 2.67 0 018.67 4c0 .59-.24 1.12-.62 1.5z"
      fill="#192547"
    />
  </svg>
);
